export enum SIGNOUT_TEST_IDS {
    CONTAINER = 'signout_modal_container',
    TITLE = 'signout_modal_title',
    MESSAGE = 'signout_modal_message',
    CONFIRM_BUTTON = 'signout_confirm_button',
    CANCEL_BUTTON = 'signout_cancel_button',
}
